



























































import Donor from '@/comps/Donor.vue'
import LuciaGQLCore from '@/data/gql'
import { Component, Vue } from 'vue-property-decorator'

const gql = new LuciaGQLCore()

/* eslint-disable camelcase */
interface DonorGQLItem {
  tier: number,
  user: {
    id: number,
    name: string,
    avatar_url: string
  }
}
/* eslint-enable camelcase */

interface DonorsGQLResponse {
  donors: DonorGQLItem[]
}

function updateDonors (ctx: LCDonate) {
  const qry = `{
    donors {
      tier
      user {
        name
        avatar_url: avatarUrl
      }
    }
  }`

  const req: Promise<DonorsGQLResponse> = gql.request(qry)
  req.then((data: DonorsGQLResponse) => {
    ctx.donors = data.donors
    ctx.loading = false
  })
}

@Component({ components: { Donor } })
export default class LCDonate extends Vue {
  loading = true
  donors: DonorGQLItem[] = []
  mounted () {
    // updateDonors(this)
  }
}
